import { translate, translateOperationType, formatDateTime, formatVolume } from './formatters';

export function buildHeaders(locale) {
    return [
        {
            key: 'nomeArquivo',
            label: translate('col_file_name'),
            minWidth: '140px'
        },
        {
            key: 'codigoTipoTransacao',
            label: translate('col_operation'),
            minWidth: '140px',
            formatter(row) {
                return translateOperationType(row.codigoTipoTransacao);
            }
        },
        {
            key: 'produtos',
            label: translate('col_product'),
            minWidth: '100px',
            type: 'slot'
        },
        {
            key: 'dataRealizacao',
            label: translate('col_date'),
            minWidth: '100px',
            type: 'html',
            formatter(row) {
                return formatDateTime(row.dataRealizacao);
            }
        },
        {
            key: 'contratos',
            label: translate('col_contract'),
            minWidth: '110px',
            type: 'slot'
        },
        {
            key: 'empresaOrigem',
            label: translate('col_origin'),
            minWidth: '120px'
        },
        {
            key: 'armazemDestino',
            label: translate('col_destination'),
            minWidth: '120px'
        },
        {
            key: 'volumeSaidaOrigemTon',
            label: translate('col_origin_volume'),
            minWidth: '110px',
            align: 'right',
            formatter(row) {
                return formatVolume(row.volumeSaidaOrigemTon, locale);
            }
        },
        {
            key: 'volumeEntradaDestinoTon',
            label: translate('col_destination_volume'),
            minWidth: '110px',
            align: 'right',
            formatter(row) {
                return formatVolume(row.volumeEntradaDestinoTon, locale);
            }
        }
    ];
}
